import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const Footer = () => {
  return (
    <Box sx={{ p: 2, backgroundColor: '#f5f5f5', mt: 'auto', textAlign: 'center' }}>
      <Typography variant="body2" color="textSecondary">
        © {new Date().getFullYear()} - Evolution Projects
      </Typography>
    </Box>
  );
};

export default Footer;
